import { render, staticRenderFns } from "./AddBannerImage.vue?vue&type=template&id=c5fdf8c0"
import script from "./AddBannerImage.vue?vue&type=script&lang=js"
export * from "./AddBannerImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports